export default __webpack_public_path__ + "static/media/Punto_00_Finocchietti_ENG_Def.4f9665b3.aac";